import { apiNoticatoin } from "api"
import Image from "next/legacy/image"
import { useEffect, useRef, useState } from "react"
import { FormatDate, trackGA } from "lib/func"
import { initializeApp } from "firebase/app"
import { getMessaging, onMessage } from "firebase/messaging"
import { Loading, LoadingDots, notification } from "components/ui"
import { Router, useRouter } from "next/router"
import useStore from "components/ui/Context"

function NotiCation({ callBackgetCountNoti, setIsShowNoti }) {
  const { logOut } = useStore()
  const router = useRouter()
  const pageNum = useRef(1)
  const pageTab = useRef()
  // const idTab = useRef()
  const [steps, setSteps] = useState(1)
  const [tabs, setTabs] = useState()
  const [tab, setTab] = useState()
  const __tabActive = useRef(0)
  const [notications, setNotications] = useState([])
  const [noti, setNoti] = useState()
  const hasNext = useRef(true)
  const [isCallNoti, setIsCallNoti] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingScroll, setLoadingScroll] = useState(false)
  const [loaddingDetail, setLoadingDetail] = useState(false)

  const containerRef = useRef(null)

  async function getTabs() {
    try {
      setLoading(true)
      const { data, success } = await apiNoticatoin.getTabs()
      if (success) {
        setTabs(data)
        setTab(data[__tabActive.current])
        if (data?.length > 0) {
          pageTab.current = data[__tabActive.current]?.id
          pageNum.current = 1
          getNottOfTabs()
        }
      }
    } catch (error) {
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    } finally {
      // setLoading(false)
    }
  }

  async function getNottOfTabs() {
    setLoading(true)
    if (pageNum.current > 1) {
      setLoadingScroll(true)
    } else {
      setLoadingScroll(false)
    }
    try {
      const { data, success, has_next } = await apiNoticatoin.getNottOfTabs({
        page_num: pageNum.current,
        page_size: 30,
        total: 0,
        id_tab: pageTab.current
      })
      if (pageNum.current === 1) {
        setNotications(data)
      } else {
        if (success && data?.length > 0) {
          setNotications((notications) => [...notications, ...data])
          // setNotications([...notications, ...data])
        }
      }
      hasNext.current = has_next
    } catch (error) {
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    } finally {
      setLoading(false)
      setIsCallNoti(false)
      setLoadingScroll(false)
    }
  }

  async function getDetail(id) {
    setLoadingDetail(true)
    let __param = {
      noti_id: id
    }
    try {
      const { success, data } = await apiNoticatoin.getDetailNoti(__param)
      if (success) {
        setNoti(data)
      } else {
        setNoti([])
      }
    } catch (error) {
      setLoadingDetail(false)
      console.log(error)
      if (error?.response?.status === 401) {
        logOut()
        setIsShowNoti(false)
        notification.error({
          message: "Phiên đăng nhập hết hạn!"
        })
      }
    }
  }

  async function MarkRead(key, value) {
    if (key === "all") {
      let __paramMarkread = {
        is_all: true,
        id_tab: tab?.id
      }
      try {
        await apiNoticatoin.markReadNotis(__paramMarkread)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          logOut()
          setIsShowNoti(false)
          notification.error({
            message: "Phiên đăng nhập hết hạn!"
          })
        }
      }
    } else {
      try {
        await apiNoticatoin.markReadNotication(value)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          logOut()
          setIsShowNoti(false)
          notification.error({
            message: "Phiên đăng nhập hết hạn!"
          })
        }
      }
    }
    getTabs()
    callBackgetCountNoti()
  }

  function onChangeTab(value) {
    setNotications([])
    pageTab.current = value.id
    pageNum.current = 1
    getNottOfTabs()
  }

  function handerDetail(item) {
    MarkRead("one", item?.noti_id)
    if (item?.type === 5 && item?.data?.deep_link) {
      let url = item?.data?.deep_link
      let video_url = url.split("/video")[1]
      let finnal_url = "/video" + video_url
      if (window) {
        if (item?.data?.is_url_external && item?.data?.url_external) {
          window.open(item?.data?.url_external, "_blank")
        } else router?.push(window?.location?.origin + finnal_url)
      }
      setIsShowNoti(false)
    } else {
      setSteps(2)
      getDetail(item?.noti_id)
    }
  }

  function handleParentClick(event) {
    if (event.target.id === "parent") {
      setIsShowNoti(false)
    }
  }

  function handleChildClick() {}

  useEffect(() => {
    const firebaseApp = initializeApp({
      apiKey: "AIzaSyChP2yOm3j5hQHa-YdLuqn8XhkAYHQLdwI",
      authDomain: "onplus-5a601.firebaseapp.com",
      projectId: "onplus-5a601",
      storageBucket: "onplus-5a601.appspot.com",
      messagingSenderId: "190122352939",
      appId: "1:190122352939:web:6d086f9f254fc640b6256e",
      measurementId: "G-8CTEDKZ2SV"
    })

    let messaging
    try {
      messaging = getMessaging(firebaseApp)

      onMessage(messaging, (payload) => {
        if (payload?.messageId) {
          const timer = setTimeout(() => {
            getTabs()
            callBackgetCountNoti()
          }, [2000])

          return () => {
            clearTimeout(timer)
          }
        }
        // ...
      })
    } catch (err) {
      console.error("Failed to initialize Firebase Messaging", err)
    }
  }, [])

  useEffect(() => {
    getTabs()
  }, [])

  useEffect(() => {
    function handleScroll() {
      const container = containerRef.current
      if (!container) return
      const { scrollTop, scrollHeight, clientHeight } = container
      const containerHeight = scrollHeight - clientHeight
      const scrolledPercent = scrollTop / containerHeight

      if (scrolledPercent >= 1) {
        setIsCallNoti(true)
      }
    }

    const container = containerRef.current

    container?.addEventListener("scroll", handleScroll)
    return () => {
      container?.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    if (isCallNoti) {
      if (hasNext.current) {
        const timer = setTimeout(() => {
          pageNum.current = pageNum.current + 1
          getNottOfTabs()
        }, 0)
        return () => {
          clearTimeout(timer)
        }
      }
    }
  }, [isCallNoti])

  return (
    <div className="fixed w-full right-0 lg:top-16 z-0 top-12">
      <div className="md:px-10 2xl:px-12 flex justify-end md:mr-16 " onClick={handleParentClick} id="parent">
        {steps === 1 ? (
          <div
            className="max-w-[100vw] w-[524px] md:h-[700px] rounded-b-lg h-full"
            id="child"
            onClick={handleChildClick}
          >
            <div className="bg-dark-700  pt-4">
              <div className="flex justify-between px-5 py-1">
                <div className="text-lg font-semibold">THÔNG BÁO</div>
                <div
                  className={
                    tab?.count > 0
                      ? "text-sm flex items-center cursor-pointer text-dark-100"
                      : "text-sm flex items-center cursor-pointer text-dark-300"
                  }
                  onClick={() => {
                    MarkRead("all")
                  }}
                >
                  <div className={"mr-2"}>Đọc tất cả</div>
                  {tab?.count > 0 ? iconText : iconTextDark}
                </div>
              </div>
              <div className="flex px-5 pt-1 text-sm text-dark-300">
                {tabs?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        __tabActive.current === index
                          ? "mr-6 relative cursor-pointer text-primary-500 border-[#52B5F9] border-b-2 p-1"
                          : "mr-6 relative cursor-pointer text-dark-300 p-1"
                      }
                      onClick={() => {
                        if (index !== __tabActive.current) {
                          setTab(item)
                          __tabActive.current = index
                          onChangeTab(item)
                        }
                      }}
                    >
                      <div className="right-[-2px] top-[-2px] w-1 absolute">{item?.count > 0 && dotRed}</div>
                      <div>{item?.name}</div>
                    </div>
                  )
                })}
              </div>
              <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8" }}></div>
            </div>
            <div
              className="bg-dark-500 w-full max-h-[78vh] md:max-h-[500px] px-4 text-dark-300 overflow-y-auto overflow-x-hidden scroll__video rounded-b-lg pt-4 pb-2"
              ref={containerRef}
            >
              {notications?.length > 0 ? (
                <>
                  {notications?.map((item, index) => {
                    return (
                      <div key={index}>
                        {item?.image_uri ? (
                          <CardImg item={item} handerDetail={handerDetail} />
                        ) : (
                          <CardText item={item} handerDetail={handerDetail} />
                        )}
                      </div>
                    )
                  })}
                  {loadingScroll && (
                    <div className="flex justify-center items-center">
                      <div className="donut-scroll"></div>
                    </div>
                  )}
                </>
              ) : (
                <div className="flex flex-col justify-center items-center h-[400px] rounded-b-lg">
                  {loading && pageNum.current === 1 ? (
                    <>
                      <div className="flex items-center justify-center">
                        <div className="donut"></div>
                      </div>
                    </>
                  ) : (
                    <>
                      {bigBell}
                      <div className="font-thin">Bạn chưa có thông báo</div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="w-[524px] rounded-b-lg bg-[#0E1E3E] h-[75vh] overflow-y-auto" id="child" ref={containerRef}>
            <div className="p-4">
              <div className="flex  p-1">
                <div className="text-lg font-semibold flex">
                  <span
                    onClick={() => {
                      setSteps(1)
                      setNoti([])
                    }}
                    className="cursor-pointer"
                  >
                    {back}
                  </span>
                  &nbsp; CHI TIẾT THÔNG BÁO
                </div>
              </div>
            </div>
            <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8" }}></div>
            {noti?._id ? (
              <div className="bg-dark-500 w-full px-6 py-4 rounded-b-lg">
                <div className="mb-2">
                  {noti?.image_uri && (
                    <Image
                      // alt="erro"
                      className="rounded-lg"
                      src={noti?.image_uri || "https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png"}
                      width={680}
                      height={380}
                      onError={() => {
                        "https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png"
                      }}
                    />
                  )}
                </div>
                <div className="grid grid-cols-12">
                  <div className="text-lg text-dark-100 font-medium mb-3 col-span-10">{noti?.title}</div>
                  <div className="text-sm col-span-2 text-dark-300">{FormatDate(noti?.created_at)}</div>
                </div>
                <div className="text-sm text-primary-100">{noti?.body}</div>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center h-[400px] rounded-b-lg">
                {loaddingDetail ? (
                  <>
                    <div className="flex items-center justify-center">
                      <div className="donut"></div>
                    </div>
                  </>
                ) : (
                  <>
                    {bigBell} <div className="text-dark-300">Thông báo không tồn tại</div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default NotiCation

function CardText({ item, handerDetail }) {
  const { body, title, created_at, is_read } = item
  return (
    <div
      className="bg-dark p-4 rounded-lg mb-2 cursor-pointer"
      onClick={() => {
        handerDetail(item)
      }}
    >
      <div className="mb-1  flex justify-between">
        <div className="font-medium text-dark-100 text-base w-60 line-clamp-1 cursor-pointer">{title}</div>
        <div className="text-sm flex justify-end w-28 ">
          {FormatDate(created_at)} {!is_read && dotRed}
        </div>
      </div>
      <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8" }}></div>
      <div className="line-clamp-2 mt-2 text-sm ">{body}</div>
    </div>
  )
}

function CardImg({ item, handerDetail }) {
  const { body, title, created_at, is_read, image_uri } = item
  const [urcImage, setSrcImage] = useState("https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png")

  useEffect(() => {
    setSrcImage(image_uri)
  }, [image_uri])

  return (
    <div
      className=" bg-dark p-4 rounded-lg mb-2 grid grid-cols-3 cursor-pointer"
      onClick={() => {
        handerDetail(item)
      }}
    >
      <div className="col-span-1">
        <Image
          // alt="erro"
          className="cursor-pointer rounded-lg"
          src={urcImage || "https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png"}
          width={340}
          height={190}
          onError={() => {
            setSrcImage("https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png")
          }}
        />
      </div>
      <div className="col-span-2 ml-4">
        <div className="mb-1 font-medium text-dark-100 text-base cursor-pointer flex justify-between">
          <div className="line-clamp-1">{title}</div>
          <div> {!is_read && dotRed}</div>
        </div>
        <div className="line-clamp-1 mt-1 text-sm">{body}</div>
        <div className="text-sm mt-1"> {FormatDate(created_at)}</div>
      </div>
    </div>
  )
}

const back = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 6.69788L14.8449 4.5L7 12.5L14.8449 20.5L17 18.3021L11.3104 12.5L17 6.69788Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)

const dotRed = (
  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="3" fill="#EF4035" />
  </svg>
)
const dotBlack = (
  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="3" fill="#000E2B" />
  </svg>
)
const iconText = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 21.5L14.25 18.5L15.41 17.34L17 18.93L20.59 15.34L21.75 16.75M12.8 21.5H5C3.89 21.5 3 20.61 3 19.5V5.5C3 4.39 3.89 3.5 5 3.5H19C20.11 3.5 21 4.39 21 5.5V13.3C20.39 12.95 19.72 12.7 19 12.58V5.5H5V19.5H12.08C12.2 20.22 12.45 20.89 12.8 21.5ZM12 17.5H7V15.5H12M14.68 13.5H7V11.5H17V12.58C16.15 12.72 15.37 13.04 14.68 13.5ZM17 9.5H7V7.5H17"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)
const iconTextDark = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 21.5L14.25 18.5L15.41 17.34L17 18.93L20.59 15.34L21.75 16.75M12.8 21.5H5C3.89 21.5 3 20.61 3 19.5V5.5C3 4.39 3.89 3.5 5 3.5H19C20.11 3.5 21 4.39 21 5.5V13.3C20.39 12.95 19.72 12.7 19 12.58V5.5H5V19.5H12.08C12.2 20.22 12.45 20.89 12.8 21.5ZM12 17.5H7V15.5H12M14.68 13.5H7V11.5H17V12.58C16.15 12.72 15.37 13.04 14.68 13.5ZM17 9.5H7V7.5H17"
      fill="white"
      fillOpacity="0.38"
    />
  </svg>
)
const bigBell = (
  <svg width="119" height="133" viewBox="0 0 119 133" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8667_155792)">
      <path
        d="M118.057 110.452C117.354 107.538 116.035 104.807 114.189 102.44C108.782 95.3548 105.844 86.7089 105.818 77.8123V70.9822C105.818 70.4665 105.612 69.972 105.246 69.6074C104.879 69.2428 104.382 69.0379 103.864 69.0379C103.346 69.0379 102.849 69.2428 102.483 69.6074C102.117 69.972 101.911 70.4665 101.911 70.9822V77.8123C101.921 83.3968 102.986 88.9295 105.05 94.1225H13.1294C15.1941 88.9297 16.2597 83.3969 16.2707 77.8123V56.4257C16.2601 50.7301 17.4035 45.0909 19.6327 39.8452C19.8303 39.3711 19.8314 38.8384 19.6359 38.3634C19.4404 37.8884 19.0641 37.5097 18.5891 37.3097C18.1141 37.1098 17.5789 37.1049 17.1003 37.2962C16.6217 37.4874 16.2385 37.8593 16.0343 38.3306C13.6008 44.0553 12.3524 50.2097 12.3637 56.4257V77.8123C12.3381 86.7093 9.39866 95.3554 3.9909 102.44C2.14608 104.808 0.828266 107.539 0.124893 110.452C-0.0356671 111.14 -0.0380455 111.856 0.117935 112.545C0.273916 113.234 0.584231 113.88 1.02574 114.433C1.46725 114.986 2.02855 115.433 2.6678 115.74C3.30704 116.047 4.00773 116.207 4.71761 116.207H44.2255C44.1528 116.795 44.1163 117.388 44.1161 117.98C44.1151 119.678 44.4092 121.363 44.9854 122.961C45.1605 123.448 45.5227 123.845 45.9922 124.066C46.4616 124.287 47 124.313 47.4889 124.139C47.9777 123.964 48.3769 123.604 48.5988 123.137C48.8206 122.669 48.8468 122.134 48.6717 121.647C48.2463 120.471 48.0295 119.23 48.031 117.98C48.031 117.386 48.0793 116.793 48.1755 116.207H69.6994C69.7956 116.793 69.8439 117.386 69.8439 117.98C69.8408 120.859 68.6903 123.619 66.6449 125.655C64.5995 127.691 61.8262 128.836 58.9335 128.839C57.2575 128.843 55.6035 128.459 54.1025 127.717C53.64 127.502 53.1111 127.475 52.6292 127.643C52.1473 127.811 51.7507 128.16 51.5241 128.616C51.2976 129.071 51.2593 129.597 51.4173 130.08C51.5754 130.563 51.9172 130.966 52.3697 131.201C54.409 132.21 56.6562 132.732 58.9335 132.727C62.8621 132.723 66.6285 131.168 69.4065 128.403C72.1844 125.639 73.7468 121.89 73.7509 117.98C73.7504 117.388 73.7145 116.795 73.6435 116.207H113.464C114.174 116.207 114.875 116.047 115.514 115.74C116.153 115.433 116.714 114.986 117.156 114.433C117.597 113.88 117.908 113.234 118.064 112.545C118.22 111.856 118.217 111.14 118.057 110.452ZM114.097 112.008C114.023 112.104 113.927 112.182 113.817 112.235C113.707 112.288 113.586 112.315 113.464 112.313H4.71761C4.5964 112.312 4.4769 112.284 4.36797 112.231C4.25905 112.179 4.1635 112.102 4.08842 112.007C4.01335 111.912 3.96068 111.802 3.93432 111.684C3.90797 111.567 3.90861 111.444 3.9362 111.327C4.51398 108.951 5.59272 106.724 7.1009 104.794C8.72643 102.665 10.1563 100.395 11.3732 98.011H106.808C108.025 100.395 109.454 102.666 111.081 104.794C112.591 106.726 113.672 108.954 114.251 111.333C114.279 111.45 114.28 111.573 114.253 111.691C114.227 111.809 114.173 111.919 114.097 112.013V112.008Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M21.3966 32.2841C21.8194 32.5821 22.3438 32.7008 22.8545 32.614C23.3652 32.5272 23.8203 32.2421 24.1198 31.8213C25.6398 29.6886 27.3516 27.698 29.2341 25.8739C30.575 26.4868 32.0493 26.7539 33.5212 26.6506C34.9931 26.5473 36.4152 26.0769 37.6564 25.2828C38.8976 24.4887 39.918 23.3964 40.6235 22.1066C41.3291 20.8169 41.6971 19.3711 41.6936 17.9025C41.6936 17.7567 41.6936 17.6129 41.6838 17.469C44.2664 16.3239 46.9574 15.4381 49.7167 14.8248C51.5639 14.4226 53.2166 13.4018 54.3987 11.933C55.5809 10.4642 56.221 8.6362 56.2121 6.75429C56.2021 6.37179 56.2692 5.99117 56.4093 5.63488C56.5495 5.27859 56.7599 4.95384 57.0282 4.67978C57.2965 4.40572 57.6172 4.18791 57.9714 4.03919C58.3256 3.89046 58.7062 3.81384 59.0906 3.81384C59.4751 3.81384 59.8556 3.89046 60.2099 4.03919C60.5641 4.18791 60.8848 4.40572 61.1531 4.67978C61.4214 4.95384 61.6318 5.27859 61.7719 5.63488C61.9121 5.99117 61.9792 6.37179 61.9691 6.75429C61.9593 8.63659 62.5987 10.4653 63.7806 11.9348C64.9624 13.4044 66.6151 14.4259 68.4626 14.8287C75.953 16.4933 82.8528 20.1401 88.4334 25.384C87.3366 26.757 86.7245 28.4512 86.6917 30.2049C86.6589 31.9587 87.2073 33.6744 88.2521 35.087C89.2969 36.4996 90.78 37.5305 92.4722 38.0205C94.1645 38.5105 95.9718 38.4323 97.6149 37.7979C100.441 43.603 101.91 49.9693 101.913 56.4198V61.3854C101.913 61.9011 102.118 62.3956 102.485 62.7602C102.851 63.1248 103.348 63.3297 103.866 63.3297C104.384 63.3297 104.881 63.1248 105.248 62.7602C105.614 62.3956 105.82 61.9011 105.82 61.3854V56.4198C105.818 49.1611 104.114 42.003 100.842 35.5154C102.014 34.1439 102.686 32.4188 102.749 30.6197C102.812 28.8206 102.263 27.053 101.19 25.6035C100.118 24.1539 98.5849 23.1073 96.8399 22.6334C95.0949 22.1595 93.2403 22.2861 91.5766 22.9926C85.4077 17.0369 77.7023 12.8976 69.3144 11.0336C68.3363 10.8193 67.4615 10.2779 66.8359 9.49952C66.2102 8.72119 65.8715 7.75297 65.8762 6.75623C65.8915 5.85973 65.7272 4.96918 65.3931 4.1365C65.059 3.30383 64.5616 2.5457 63.93 1.90633C63.2984 1.26696 62.5452 0.759154 61.7143 0.412518C60.8834 0.065883 59.9915 -0.11264 59.0906 -0.11264C58.1897 -0.11264 57.2978 0.065883 56.467 0.412518C55.6361 0.759154 54.8829 1.26696 54.2513 1.90633C53.6197 2.5457 53.1223 3.30383 52.7882 4.1365C52.454 4.96918 52.2898 5.85973 52.3051 6.75623C52.3098 7.75297 51.971 8.72119 51.3454 9.49952C50.7198 10.2779 49.845 10.8193 48.8669 11.0336C46.0372 11.6635 43.2732 12.5566 40.6114 13.701C40.0238 12.6284 39.2172 11.69 38.2436 10.946C37.27 10.202 36.1508 9.66891 34.9579 9.38094C33.7649 9.09296 32.5247 9.05648 31.3168 9.27384C30.1089 9.4912 28.96 9.95759 27.9439 10.6431C26.9278 11.3285 26.067 12.2179 25.4168 13.2541C24.7666 14.2903 24.3413 15.4504 24.1683 16.6599C23.9952 17.8694 24.0783 19.1015 24.4121 20.2771C24.7459 21.4528 25.323 22.5459 26.1065 23.4864C24.211 25.3656 22.4798 27.4021 20.9316 29.5738C20.6322 29.9946 20.5129 30.5165 20.6001 31.0248C20.6873 31.533 20.9738 31.986 21.3966 32.2841ZM98.8476 30.3398C98.8499 31.1521 98.61 31.9467 98.1583 32.6232C97.7066 33.2997 97.0633 33.8276 96.31 34.14C95.5567 34.4524 94.7271 34.5354 93.9264 34.3783C93.1257 34.2213 92.3898 33.8313 91.8119 33.2578C91.234 32.6843 90.8401 31.953 90.68 31.1565C90.5199 30.36 90.6009 29.5342 90.9127 28.7836C91.2244 28.0329 91.753 27.3912 92.4314 26.9397C93.1098 26.4882 93.9076 26.2472 94.7237 26.2472C95.8158 26.2482 96.8629 26.6799 97.6359 27.4477C98.4088 28.2155 98.8445 29.2569 98.8476 30.3437V30.3398ZM32.8891 13.0264C33.8576 13.026 34.8044 13.3114 35.6099 13.8465C36.4154 14.3816 37.0435 15.1424 37.4146 16.0326C37.7858 16.9229 37.8834 17.9027 37.6951 18.8482C37.5068 19.7936 37.0411 20.6623 36.3568 21.3444C35.6726 22.0265 34.8005 22.4914 33.8508 22.6803C32.9011 22.8692 31.9165 22.7736 31.0214 22.4056C30.1263 22.0377 29.3609 21.4138 28.822 20.613C28.283 19.8122 27.9948 18.8703 27.9936 17.9064C27.9936 16.6135 28.5091 15.3734 29.427 14.4585C30.3448 13.5435 31.59 13.0285 32.8891 13.0264Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M58.7477 63.8799H58.7165C56.4267 63.8521 54.2005 64.6294 52.43 66.0749C52.2251 66.2366 52.0549 66.4377 51.9295 66.6661C51.804 66.8945 51.726 67.1456 51.6999 67.4046C51.6738 67.6636 51.7003 67.9252 51.7777 68.1738C51.8551 68.4225 51.9819 68.6531 52.1505 68.8521C52.3192 69.051 52.5262 69.2142 52.7594 69.3321C52.9926 69.4499 53.2473 69.5199 53.5082 69.538C53.7691 69.556 54.031 69.5218 54.2783 69.4372C54.5257 69.3526 54.7534 69.2195 54.9481 69.0457C56.0182 68.1993 57.3498 67.7479 58.7165 67.7683H58.736C60.1096 67.7513 61.4463 68.2112 62.516 69.069C62.9101 69.4042 63.4217 69.5699 63.9385 69.5296C64.4552 69.4893 64.9347 69.2463 65.2715 68.8542C65.6082 68.4621 65.7747 67.9528 65.7342 67.4385C65.6937 66.9242 65.4496 66.447 65.0556 66.1119C63.284 64.6495 61.0493 63.8587 58.7477 63.8799Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M70.4416 56.1515H70.4162C69.8981 56.1515 69.4012 56.3564 69.0348 56.721C68.6685 57.0856 68.4626 57.5801 68.4626 58.0958C68.4626 58.6114 68.6685 59.1059 69.0348 59.4705C69.4012 59.8352 69.8981 60.04 70.4162 60.04H70.4435C70.9616 60.04 71.4585 59.8352 71.8249 59.4705C72.1912 59.1059 72.397 58.6114 72.397 58.0958C72.397 57.5801 72.1912 57.0856 71.8249 56.721C71.4585 56.3564 70.9616 56.1515 70.4435 56.1515H70.4416Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M47.5795 56.1515C47.0614 56.1515 46.5645 56.3564 46.1981 56.721C45.8318 57.0856 45.626 57.5801 45.626 58.0958C45.626 58.6114 45.8318 59.1059 46.1981 59.4705C46.5645 59.8352 47.0614 60.04 47.5795 60.04H47.6049C48.123 60.04 48.6199 59.8352 48.9862 59.4705C49.3526 59.1059 49.5584 58.6114 49.5584 58.0958C49.5584 57.5801 49.3526 57.0856 48.9862 56.721C48.6199 56.3564 48.123 56.1515 47.6049 56.1515H47.5795Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M107.377 24.7288L109.135 26.4786L107.377 28.2284C107.19 28.4077 107.041 28.6223 106.939 28.8595C106.836 29.0967 106.783 29.3518 106.78 29.61C106.778 29.8681 106.828 30.1241 106.926 30.3631C107.024 30.602 107.169 30.8191 107.352 31.0016C107.536 31.1842 107.754 31.3286 107.994 31.4263C108.234 31.5241 108.491 31.5733 108.751 31.571C109.01 31.5688 109.266 31.5151 109.505 31.4133C109.743 31.3114 109.959 31.1632 110.139 30.9775L111.897 29.2277L113.655 30.9775C113.835 31.1632 114.051 31.3114 114.289 31.4133C114.528 31.5151 114.784 31.5688 115.043 31.571C115.303 31.5733 115.56 31.5241 115.8 31.4263C116.04 31.3286 116.258 31.1842 116.442 31.0016C116.625 30.8191 116.77 30.602 116.868 30.3631C116.967 30.1241 117.016 29.8681 117.014 29.61C117.012 29.3518 116.958 29.0967 116.855 28.8595C116.753 28.6223 116.604 28.4077 116.418 28.2284L114.659 26.4786L116.418 24.7288C116.6 24.5477 116.744 24.3328 116.843 24.0962C116.941 23.8597 116.992 23.6061 116.992 23.35C116.992 23.0939 116.941 22.8403 116.843 22.6037C116.745 22.367 116.6 22.152 116.418 21.9709C116.237 21.7897 116.021 21.646 115.783 21.5479C115.545 21.4498 115.29 21.3993 115.033 21.3992C114.776 21.3991 114.521 21.4495 114.283 21.5474C114.046 21.6453 113.829 21.7889 113.647 21.9699L111.889 23.7197L110.131 21.9699C109.95 21.7894 109.734 21.6462 109.497 21.5486C109.26 21.4509 109.006 21.4007 108.749 21.4008C108.493 21.4009 108.239 21.4513 108.002 21.5491C107.765 21.6469 107.549 21.7902 107.368 21.9709C107.186 22.1515 107.043 22.3659 106.945 22.6019C106.846 22.8379 106.796 23.0908 106.796 23.3461C106.796 23.8619 107.002 24.3564 107.369 24.721L107.377 24.7288Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M99.1037 18.5928C100.936 18.5928 102.727 18.052 104.25 17.039C105.774 16.0259 106.961 14.586 107.662 12.9014C108.363 11.2167 108.547 9.36295 108.189 7.57453C107.832 5.7861 106.95 4.14333 105.654 2.85395C104.358 1.56457 102.708 0.68649 100.911 0.330751C99.1139 -0.0249887 97.2513 0.15759 95.5586 0.855398C93.8659 1.55321 92.4192 2.7349 91.4013 4.25105C90.3834 5.76721 89.8401 7.54972 89.8401 9.37318C89.8427 11.8176 90.8195 14.1611 92.5562 15.8896C94.2929 17.618 96.6476 18.5902 99.1037 18.5928ZM99.1037 4.04402C100.163 4.04402 101.199 4.35673 102.08 4.94261C102.961 5.52848 103.647 6.3612 104.053 7.33545C104.458 8.30969 104.564 9.3817 104.357 10.4159C104.15 11.4501 103.64 12.4 102.891 13.1455C102.141 13.891 101.187 14.3985 100.147 14.604C99.1083 14.8095 98.0312 14.7037 97.0525 14.2999C96.0737 13.8961 95.2373 13.2125 94.6489 12.3355C94.0606 11.4586 93.7467 10.4277 93.7471 9.37318C93.7492 7.96009 94.3143 6.6055 95.3184 5.60648C96.3226 4.60746 97.6838 4.04556 99.1037 4.04402Z"
        fill="white"
        fillOpacity="0.38"
      />
      <path
        d="M9.18724 15.8903C9.55358 16.2548 10.0504 16.4595 10.5684 16.4595C11.0864 16.4595 11.5832 16.2548 11.9495 15.8903L13.1509 14.6946L14.3504 15.8903C14.7169 16.2551 15.2141 16.46 15.7325 16.46C16.2509 16.46 16.748 16.2551 17.1146 15.8903C17.4812 15.5254 17.6871 15.0306 17.6871 14.5147C17.6871 13.9988 17.4812 13.504 17.1146 13.1392L15.9132 11.9454L17.1146 10.7497C17.296 10.5691 17.4398 10.3546 17.5379 10.1187C17.636 9.8827 17.6865 9.62981 17.6864 9.37444C17.6863 9.11906 17.6357 8.86621 17.5374 8.63031C17.4391 8.39441 17.2951 8.18009 17.1136 7.99958C16.9321 7.81906 16.7167 7.6759 16.4796 7.57826C16.2425 7.48061 15.9884 7.4304 15.7318 7.43049C15.4752 7.43058 15.2212 7.48097 14.9841 7.57878C14.7471 7.67659 14.5318 7.81991 14.3504 8.00055L13.1509 9.19431L11.9456 8.00055C11.7671 7.80783 11.5513 7.65301 11.3112 7.5454C11.0711 7.4378 10.8116 7.37962 10.5483 7.37438C10.285 7.36914 10.0233 7.41693 9.77905 7.51489C9.53479 7.61285 9.31294 7.75896 9.12686 7.94442C8.94077 8.12988 8.79429 8.35088 8.69621 8.59412C8.59812 8.83736 8.55047 9.09783 8.55611 9.35987C8.56175 9.62191 8.62057 9.88011 8.72903 10.119C8.83749 10.3578 8.99335 10.5723 9.18724 10.7497L10.3828 11.9454L9.18334 13.1411C8.81763 13.5062 8.61259 14.001 8.61333 14.5165C8.61406 15.032 8.8205 15.5262 9.18724 15.8903Z"
        fill="white"
        fillOpacity="0.38"
      />
    </g>
    <defs>
      <clipPath id="clip0_8667_155792">
        <rect width="118.182" height="132.727" fill="white" transform="translate(-0.000244141)" />
      </clipPath>
    </defs>
  </svg>
)
